import { render, staticRenderFns } from "./I18nSwitch.vue?vue&type=template&id=3606c9be&"
import script from "./I18nSwitch.vue?vue&type=script&lang=ts&"
export * from "./I18nSwitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports